import { useI18n } from "@/i18n/I18nProvider";

export default function MarqueeStrip() {
  const { t } = useI18n();
  const items = t.marquee;
  const loop = [...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-line bg-surface-muted py-5 overflow-hidden relative"
    >
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div
        className="marquee-track relative flex gap-14 whitespace-nowrap will-change-transform"
        style={{ animation: "marquee 70s linear infinite" }}
      >
        {loop.map((it, i) => (
          <div key={i} className="flex items-center gap-14 shrink-0">
            <span className="font-heading text-sm md:text-base font-semibold uppercase tracking-[0.3em] text-ink-primary/70">
              {it}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand-red shrink-0" aria-hidden />
          </div>
        ))}
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0);} to { transform: translateX(-50%);} }`}</style>
    </div>
  );
}
